const ALLOW_MEDIA_EXTENSIONS =
  "mp4,mov,avi,mpg,3gp,3g2,3gp2,asf,mts,m2ts,mod,ts,vob,xesc,mpeg,mpg,m2v,ismv,wmv,webm";

export { ALLOW_MEDIA_EXTENSIONS };
